// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectDepartureQueryResult, selectDeparturesPageLoading, selectDeparturesShowInitWaitingMessage} from '../_selectors/departure.selectors';

export class DeparturesDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectDeparturesPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectDeparturesShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectDepartureQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
